export default "__VITE_ASSET__D1lWL_b0__"